import { Injectable } from '@angular/core';

@Injectable()
export class DirectionsService {
  get(lat: number, lng: number) {
    window.open(`https://maps.google.com/maps?q=${lat},${lng}`, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/providers/directions/directions.ts